module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD7SURBVHgB7ZM9TgMxEIXfG0WI0jdgj5AyqQIn4Aq+ARSEFlJDwRH2CtwAKuiAGzg3cI2Qh7F3Nz9KqrhJkU8azfNYGv/MDP3lrcPv2Q2gDZTOvBkbFFLWDltoBCT2OhRHBCS8t59PLf3k/hHUBwvHzrT3jGCK2IcOB2I4sFurLkaWbGbqrf14vkIFfnr3Bcq1WLIxyIBaFD/526RcOekS9QQzJ+XPhBeopzGLUjIrx6iF+VL6PbK3v+Yq++lcLRpMR4t11WV5xi5De9GqXHRur6xlwbzvJ3MPSbN1OwwerrdN+rYqmcOqvRKXOP97wdHD0+gdzmn0jnf0/gFep6u5/8wXxwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sidebar-icons/product-active.png
// module id = d0I7
// module chunks = 37